import React from 'react';
import { StyledCloudImage } from './UniversalSearchCard.styles';
import { registryPageData } from '@data-ts/pages/registry';
import { Card } from '@sections/registry/components';
import { themeSpace } from '@utils/styledTheme.util';
import { useTheme } from 'styled-components';
const {
  shopSection: { universalSearchCard },
} = registryPageData;

export const UniversalSearchCard = () => {
  const theme = useTheme();
  return (
    <Card
      eyebrow={universalSearchCard.eyebrow}
      eyebrowVariant="featureHed17"
      eyebrowColor="accentBlue4"
      title={universalSearchCard.title}
      titleVariant="calloutHed32"
      titleColor="mono1"
      wrapperStyles={{ gap: themeSpace(8)({ theme }) }}
    >
      <StyledCloudImage alt="search" optimization="none" src={'registry-q12024/gifts-you-want/hero-searchbar@4x.png'} />
    </Card>
  );
};
